import { ScrollArea } from '@/components/ui/scroll-area/scroll-area.component';
import { cloneElement } from 'react';
import { RootLayout } from '../_root/root.layout';
import { useTailoringLayout } from './use-tailoring-layout.hook';

type TailoringLayoutProps = {
  loading?: boolean;
  loadingElement?: React.ReactNode;
  topbar: React.ReactNode;
  leftAreaFixed: React.ReactNode | null;
  leftArea: React.ReactNode;
  rightAreaFixed: React.ReactNode;
  rightArea: React.ReactNode;
};

export const TailoringLayout = ({
  loading,
  loadingElement,
  topbar,
  leftAreaFixed,
  leftArea,
  rightAreaFixed,
  rightArea,
}: TailoringLayoutProps) => {
  const { left, right, container } = useTailoringLayout();
  return (
    <RootLayout>
      {topbar}
      {loading &&
        cloneElement(loadingElement as React.ReactElement, {
          height: container.height,
          leftWidth: left.width,
          rightWidth: right.width,
        })}
      {!loading && (
        <div
          className="mt-[144px] mx-18 pt-6 pb-4 flex flex-row justify-between"
          style={{
            height: container.height,
          }}
        >
          <div
            style={{
              width: left.width,
            }}
            className="overflow-scroll shadow"
          >
            <div ref={left.fixed.ref}>{leftAreaFixed}</div>
            <ScrollArea
              style={{
                height: left.scroll.height,
              }}
            >
              {leftArea &&
                cloneElement(leftArea as React.ReactElement, {
                  height: left.scroll.height,
                })}
            </ScrollArea>
          </div>
          <div
            style={{
              width: right.width,
            }}
          >
            <div ref={right.fixed.ref}>{rightAreaFixed}</div>
            <ScrollArea
              style={{
                height: right.scroll.height,
              }}
            >
              {rightArea && cloneElement(rightArea as React.ReactElement, { height: right.scroll.height })}
            </ScrollArea>
          </div>
        </div>
      )}
    </RootLayout>
  );
};
